import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
@Component({
  selector: 'app-attachable-voucher-list',
  templateUrl: './../../../templates/forms/modals/attachable-voucher-list.component.html',
})
export class AttachableVoucherListComponent implements OnInit {
  @Input()
  config: any;

  @Input()
  modalShow: boolean = true;

  @Input()
  extarnalValue: string;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;

  voucherList: any[] = [];

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "AttachedVoucherGrid"

  constructor(public langService: LangService, private comService: CommonService, public gridService:GridService) {
    this.colObj = [
      { headerName: langService.langData.voucherId, field: 'VOUCHER', sortable: true, resizable: true, hide: false },
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId); 
    
    
  }

  onGridReady(grid) {
    this.grid = grid;
    let params = {
      P_QUERYOPTIONS: this.extarnalValue,
      P_V_NO: null,
      P_FROM_DATE: null,
      P_TO_DATE: null,
      P_VTYPE_NO: null,
      P_BU_NO: null,
      P_MODULE_NO: null,
      P_POST_FLAG: null,
      P_CHECK_FLAG: null,

    };
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.comService.getVouchers(params).subscribe(result => {
      this.voucherList = result.body;
      console.log("this.voucherList", this.voucherList);
    });
  }
  itemClick(_item) {
    console.log("_item", _item);
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }

}